export type TabsListItem = {
  label: string;
  value: string;
};

export type RepairListItem = {
  id: string;
  title: string;
  createTime: string;
  status: string;
  content: string;
};

export type repairStatusMapType = {
  text?: string;
  textColor?: string;
  backGroundColor?: string;
  icon?: any;
};

export type RepairDetailItemType = {
  reporterPhone?: string,
  activeStatus?: string,
  assignedDeptId?:  string,
  assignedPostId?:  string,
  assignedUserId?:  string,
  categorySub?: string;
  categoryTop?: string;
  communityId?: string;
  customerName?: string;
  dispatchMethod?: string;
  dispatchTime?: string;
  dispatchUserId?: number;
  dispatchUserName?: number;
  floorId?: string;
  ticketContent?: string,
  secondCategoryName?: string;
  firstCategoryName?: string;
  issueTemplateId?: string;
  issueTemplateTitle?: string;
  paidAmount?: string;
  pendingTime?: string;
  phone?: string;
  position?: string;
  positionDesc?: string;
  regionId?: string;
  reporter?: string;
  reporterType?: string;
  urgent?: string;
  ticketNo?: string;
  ticketStatus?: string;
  type?: string;
  telPhone?: string;
  roomName?: string;
  sequenceNbr?: string;
  roomId?: string;
  image?: string;
  firstEventName?: string;
  firstEventId?: string;
  secondEventName?: string;
  secondEventId?: string;
  processedTime?: string;
  progressTime?: string;
  sourceType?: string;
  paidFlag?: string | number;
  ticketFeeItemList?: Array<any>,
  recordFeeList?: Array<any>,
  acceptDeptId?: string,
  acceptPositionId?: string,
  acceptCustomerId?: string,
  acceptDeptName?: string,
  unitId?: string,
  roomCode?: string,
  customerId?: string,
  address?: string,
  acceptPositionName?: string,
  acceptCustomerName?: string,
  confirmFee?: boolean
};

export const repairDetailItem: RepairDetailItemType = {
  status: 'back',
  content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  imgUrl: [require('@/assets/user/defaultImage.png')],
  backReason: '测试',
  backTime: '2024-09-19 12:00',
  address: '天津市',
  id: '1',
};

export const tabsList: Array<TabsListItem> = [

  
  {
    label: '待处理',
    value: 'PENDING_PROCESSING,PENDING_DISPATCH,PENDING_ACCEPT,REJECTED,PENDING_REVIEW',
  },
  {
    label: '处理中',
    value: 'IN_PROGRESS',
  },
  {
    label: '已完成',
    value: 'COMPLETED,WITHDRAWN',
  }
];

export const repairList: Array<RepairListItem> = [
  {
    id: '1',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'accept',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '2',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'progress',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '3',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'back',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '4',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'completed',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '5',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'canceled',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '6',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'timeout',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
  {
    id: '6',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'pending',
    content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  },
];
/** 
 * accept 待接单,pending 待处理, progress 处理中,reassign 已转派, completed 已完成,back 已退回, canceled 已撤回 , timeout 已超时
 */
/**
 *   'PENDING_DISPATCH': '待派单',
  'PENDING_ACCEPT': '待接单',
  'PENDING_PROCESSING': '待处理',
  'IN_PROGRESS': '处理中',
  'COMPLETED': '已完成',
  'WORK_FINISHED': '已完工',
  'WITHDRAWN': '已撤回',
 * 
 * 
 * 
 * 
 */


export const repairStatusMap: Record<string, repairStatusMapType> = {
 
  'PENDING_DISPATCH': {
    text: '待派单',
    textColor: '#0B2FFF',
    backGroundColor: 'rgba(11, 47, 255, 0.10)',
    icon: require('@/assets/repair/check.png'),
  },
  'PENDING_ACCEPT': {
    text: '待接单',
    textColor: '#0B2FFF',
    backGroundColor: 'rgba(11, 47, 255, 0.10)',
    icon: require('@/assets/repair/check.png'),
  },
  'PENDING_PROCESSING': {
    text: '待处理',
    textColor: '#0B2FFF',
    backGroundColor: 'rgba(11, 47, 255, 0.10)',
    icon: require('@/assets/repair/check.png'),
  },
  'IN_PROGRESS': {
    text: '处理中',
    textColor: '#9221E5',
    backGroundColor: 'rgba(146, 33, 229, 0.10)',
    icon: require('@/assets/repair/process.png'),
  },
  'PENDING_REVIEW': {
    text: '待审核',
    textColor: '#0F9C5A',
    backGroundColor: 'rgba(15, 156, 90, 0.10)',
    icon: require('@/assets/repair/back.png'),
  },
  'COMPLETED': {
    text: '已完成',
    textColor: '#3015DE',
    backGroundColor: 'rgba(48, 21, 222, 0.10)',
    icon: require('@/assets/repair/success.png'),
  },
  'WITHDRAWN': {
    text: '已撤回',
    textColor: '#FB1C1C',
    backGroundColor: 'rgba(251, 28, 28, 0.10)',
    icon: require('@/assets/repair/cancel.png'),
  },
  'REJECTED': {
    text: '已拒绝',
    textColor: '#F98026',
    backGroundColor: 'rgba(249, 128, 38, 0.10)',
    icon: require('@/assets/repair/close.png'),
  },

};


/**
 * dispatch: '待派单',
 * accept: '待接单',
 * pending: '待处理',
 *  progress: '处理中',
 *  completed: '已完成',
 *  canceled: '已撤回', 
 * 
 *  'PENDING_DISPATCH': '待派单',
  'PENDING_ACCEPT': '待接单',
  'PENDING_PROCESSING': '待处理',
  'IN_PROGRESS': '处理中',
  'COMPLETED': '已完成',
  'WORK_FINISHED': '已完工',
  'WITHDRAWN': '已撤回',
 * 
 */
export const enum repairStatusEnum {
  PENDING_DISPATCH = 'PENDING_DISPATCH',
  PENDING_ACCEPT = 'PENDING_ACCEPT',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  WORK_FINISHED = 'WORK_FINISHED',
  WITHDRAWN = 'WITHDRAWN',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
  // PENDING = 'pending',
  // DISPATCH = 'dispatch',

  // back: '已退回',
}
